import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpenbugbountyComponent } from './simple-icons-openbugbounty.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpenbugbountyComponent ],
    exports:      [ SimpleIconsOpenbugbountyComponent ],
    bootstrap:    []
})
export class SimpleIconsOpenbugbountyModule {}
